import type { FaireProductEntity } from "../../entity_types/product";

export const p_dogdf17sp2: FaireProductEntity = {
  token: "p_dogdf17sp2",
  type: "product",
  name: "Panda Pair Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8d4de08b256080fe97898ea6549cfc3980a3c4dca8bbedf2462582617dfbbc35.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abd9d738deb6918c6a9fdea9553320b0c19bb9e89f99dc83f4fa87c1a26097fc.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:13.042Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
